import { useQuery } from "react-query";
import { useMsal, useAccount } from "@azure/msal-react";
import { useTokenQuery } from "./useTokenQuery";
import { fetchWithAuth } from "../components/helpers/fetchWithAuth";

export function useClientsQuery(enabled) {
  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});
  const tokenQuery = useTokenQuery();

  return useQuery(
    "clients",
    async () => {
      let apiUrl = process.env.REACT_APP_API_URI.trim();
      return fetchWithAuth(
        `${apiUrl}/operator/clients`,
        { method: "get" },
        instance,
        account,
        inProgress,
      );
    },
    {
      enabled:
        !!enabled &&
        !!accounts.length &&
        inProgress === "none" &&
        !!tokenQuery.data,
      staleTime: 10 * 60 * 1000,
    },
  );
}
